import React,{useState,useEffect} from 'react';
import { Router, Location, Redirect,useNavigate } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import PublicMenu from './../components/menus/PublicMenu';
import TableSingleDocumentDetailsForPublic from './../components/table/TableSingleDocumentDetailsForPublic'
import {URLPREFIX,API_CORE_SERVER,RS_LABEL,DDMMYYYY_LABEL} from './../constants';
const GlobalStyles = createGlobalStyle`
	
`;
const JPage= ({formId}) =>{
	
  return(
  <div className="wraper">
 
		<GlobalStyles/>
		<PublicMenu />
		<TableSingleDocumentDetailsForPublic/>
		
  </div>	
	);
};
export default JPage;